import {Component} from '@angular/core';

@Component({
    selector: 'app-files-to-download',
    templateUrl: './files-to-download.component.html',
    styleUrls: ['./files-to-download.component.scss']
})
export class FilesToDownloadComponent {
}
